import { NavigationLinkProps } from "client/Components";
import { ReactElement, Ref, forwardRef } from "react";
import { Link, To } from "react-router";
import { convertNavigationToRouterNavigation } from "client/Navigation/connectToRouter";
import { setTrackingId } from "client/Misc/utils";

export const RouterNavigationLink = forwardRef(
	(props: NavigationLinkProps, ref: Ref<HTMLAnchorElement>): ReactElement => {
		const {
			navigation,
			options = {},
			trackingId,
			...anchorProps
		} = props;

		const to: To = convertNavigationToRouterNavigation(navigation);

		return (
			<Link
				{...anchorProps}
				{...setTrackingId(trackingId)}
				ref={ref}
				to={to}
				replace={options.shouldReplace}
				state={options.historyState}
				rel="noopener noreferrer"
			/>
		);
	}
);
RouterNavigationLink.displayName = "RouterNavigationLink";